const isValidDate = (value) => {
    if (!value) return false;

    const numericValue = Number(value);

    if (isNaN(numericValue)) return false;

    if (numericValue < Date.now()) {
        return false;
    }

    return true;
};

export default isValidDate;
